import * as React from 'react'
import styled, { PrimaryHighlight } from '../../../theme/styled'
import Done from 'material-ui/svg-icons/action/done'
import { Store, getNotificationMessage } from '../../../reducers'
import { connect } from 'react-redux'
import CSSTransition from 'react-transition-group/CSSTransition'

/* stylelint-disable block-no-empty */
const NotificationAnimation = styled.div``
/* stylelint-enable block-no-empty */

const NotificationPanel = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 36%;
  margin: 0 auto;

  width: 400px;
  height: 100px;
  z-index: 200;

  display: none;
  align-items: center;
  justify-content: center;

  color: #869097;
  background: white;
  font-size: 19px;
  box-shadow: 0 0 20px 0px rgba(0, 0, 0, 0.25);

  &.notification-enter {
    opacity: 0.01;
    display: flex;
  }

  &.notification-enter-active {
    opacity: 1;
    transition: all 0.25s;
  }

  &.notification-enter-done {
    opacity: 1;
    display: flex;
  }

  &.notification-exit  {
    opacity: 1;
    display: flex;
  }

  &.notification-exit-active {
    opacity: 0.01;
    transition: all 0.4s;
  }

  &.notification-exit-done {
    display: none;
  }

  .icon-container {
    border: 2px solid ${PrimaryHighlight};
    border-radius: 50%;
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
  }
`

type NotificationProps = {
  message: string | null
}

type NotificationState = {
  visible: boolean
  message: string
}

class Notification extends React.Component<
  NotificationProps,
  NotificationState
> {
  constructor(props: NotificationProps) {
    super(props)
    this.state = { message: '', visible: !!props.message }
  }

  componentWillReceiveProps(nextProps: NotificationProps) {
    this.setState({
      visible: !!nextProps.message,
      message: nextProps.message ? nextProps.message : this.state.message
    })
  }

  render() {
    return (
      <NotificationAnimation>
        <CSSTransition
          classNames="notification"
          in={!!this.state.visible}
          timeout={400}
        >
          <NotificationPanel>
            <div className="icon-container">
              <Done color={PrimaryHighlight} />
            </div>
            {this.state.message}
          </NotificationPanel>
        </CSSTransition>
      </NotificationAnimation>
    )
  }
}

const mapStateToProps = (state: Store.Complete) => ({
  message: getNotificationMessage(state)
})

export default connect(mapStateToProps)(Notification)



// WEBPACK FOOTER //
// ./src/Components/Workspace/NotificationPanel/index.tsx